import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const ScrollReveal = ({ children, delay = 0, className = '' }) => {
  const [ref, isVisible] = useScrollAnimation(0.1);
  return (
    <div 
      ref={ref} 
      className={`transition-all duration-1000 ${className} ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const ProcessSection = () => {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6">
        <ScrollReveal>
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-gray-900">
            Startup in 3 steps
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Step 1 */}
          <ScrollReveal delay={100}>
            <div className="flex flex-col items-center">
              <div className="w-full h-64 bg-white border border-stone-200 rounded shadow-md flex items-center justify-center p-8">
                <img 
                  src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=300&h=300&fit=crop" 
                  alt="Select incorporation structure"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-semibold mt-6 text-center text-gray-900">
                Select your incorporation structure
              </h3>
            </div>
          </ScrollReveal>

          {/* Step 2 */}
          <ScrollReveal delay={200}>
            <div className="flex flex-col items-center">
              <div className="w-full h-64 bg-white border border-stone-200 rounded shadow-md flex items-center justify-center p-8">
                <img 
                  src="https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?w=300&h=300&fit=crop" 
                  alt="Meet requirements"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-semibold mt-6 text-center text-gray-900">
                Meet the pre-requisite requirements of your chosen structure
              </h3>
            </div>
          </ScrollReveal>

          {/* Step 3 */}
          <ScrollReveal delay={300}>
            <div className="flex flex-col items-center">
              <div className="w-full h-64 bg-white border border-stone-200 rounded shadow-md flex items-center justify-center p-8">
                <img 
                  src="https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=300&h=300&fit=crop" 
                  alt="Submit details"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-semibold mt-6 text-center text-gray-900">
                Submit your decided entity details & let us handle the rest!
              </h3>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
